import Button from "antd/lib/button";
import { RegisterationText } from "texts/registerationText";

interface Props {
  value: any;
  handleResetForm: () => void;
}
const RegisterStep7 = ({ handleResetForm }: Props) => {
  return (
    <div className="w-full flex flex-col items-center justify-center h-[calc(100vh-200px)]">
      <h2 className="text-center text-[22px] font-extrabold mb-4">{RegisterationText?.successRegistration}</h2>

      <Button type="text" onClick={() => handleResetForm()} className="bg-black flex mt-4 justify-center items-center gap-x-1 text-white w-full" htmlType="submit" size="large">
        {RegisterationText?.newRegistration}
      </Button>
    </div>
  );
};
export default RegisterStep7;
